export const MAX_MARKETPLACE_COLLECTION_LEVELS = 3
export const MARKETPLACE_STORE_CONFIG_ID = '1'
